module.exports = __webpack_public_path__ + "static/media/new-booking-received.43ce0350.mp3";